(function(app) {

    app.provider("marketingTrackerContactApi",
    [
        function() {
            this.$get = [
                "marketingTrackerApiGateway", function(marketingTrackerApiGateway) {
                    var service = {};

                    service.getContactById = function (contactId) {
                        return marketingTrackerApiGateway.get("/Contacts/" + contactId);
                    };

                    service.updateContact = function (contactId, contact) {
                        return marketingTrackerApiGateway.put("/Contacts/" + contactId, contact);
                    };

                    service.getContactList = function () {
                        return marketingTrackerApiGateway.get("/Contacts");
                    };

                    service.getContactByConstantContactId = function(contactId) {
                        return marketingTrackerApiGateway.get("/Contacts/ByConstantContactId/" + contactId);
                    };

                    service.getTopEngagedContactList = function(count) {
                        return marketingTrackerApiGateway.get("/Contacts/TopEngaged/" + count);
                    };

                    service.addContact = function (contact) {
                        return marketingTrackerApiGateway.post("/Contacts", contact);
                    };

                    service.deleteContact = function (contactId) {
                        return marketingTrackerApiGateway.delete("/Contacts/" + contactId);
                    };

                    return service;
                }
            ];
        }
    ]);
})(window.app); //jshint ignore:line